import { Check, X, BadgeCheck, Power } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { mediaUrl } from "@/lib/api";

const IMG_FALLBACK = "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&q=80&w=200";

function verifyBadgeClass(status) {
  if (status === "verified") return "bg-green-600";
  if (status === "rejected") return "bg-red-600";
  return "bg-amber-500";
}

function verifyLabel(status) {
  if (status === "verified") return "Verificat";
  if (status === "rejected") return "Respins";
  return "În așteptare";
}

export default function AdminExperts({ experts, pendingExperts, onVerify, onReject, onEndorse, onActivate }) {
  return (
    <>
      <h2 className="font-bold text-lg mb-5">Experți B2B ({experts.length}) · {pendingExperts} în așteptare</h2>
      <div className="space-y-3">
        {experts.length === 0 && <div className="border border-slate-200 p-8 text-center text-slate-400">Niciun expert.</div>}
        {experts.map((e) => (
          <div key={e.id} className="border border-slate-200 p-4 flex flex-col sm:flex-row gap-4" data-testid={`admin-expert-${e.id}`}>
            <img src={mediaUrl(e.photo) || IMG_FALLBACK} alt={e.name} className="w-full sm:w-20 h-20 object-cover bg-slate-100 border border-slate-200" />
            <div className="flex-1 min-w-0">
              <div className="flex items-start justify-between gap-3 flex-wrap">
                <div className="font-semibold flex items-center gap-2">
                  {e.name}{e.company && <span className="text-slate-400 font-normal">· {e.company}</span>}
                  {e.senior && <span className="inline-flex items-center gap-1 text-amber-600 text-xs font-bold">★ Veteran</span>}
                  {e.endorsed && <span className="inline-flex items-center gap-1 text-orange-600 text-xs"><BadgeCheck className="w-3.5 h-3.5" /> Endorsed</span>}
                </div>
                <div className="flex items-center gap-2">
                  <Badge className={`rounded-none ${verifyBadgeClass(e.status)}`}>{verifyLabel(e.status)}</Badge>
                  <Badge className={`rounded-none ${e.active ? "bg-slate-900" : "bg-slate-300 text-slate-700"}`}>{e.active ? "Public" : "Inactiv"}</Badge>
                </div>
              </div>
              <div className="text-xs text-slate-500 mt-1">{e.contact_email}{e.contact_phone ? ` · ${e.contact_phone}` : ""}{e.location ? ` · ${e.location}` : ""}</div>
              <div className="text-xs text-slate-500 mt-1">{(e.specializations || []).join(", ")}</div>
              {e.certifications && <div className="text-xs text-slate-500 mt-1"><span className="font-semibold">Certificări:</span> {e.certifications}</div>}
              <div className="flex flex-wrap gap-2 mt-3">
                {e.status !== "verified" && <button onClick={() => onVerify(e.id)} className="inline-flex items-center gap-1.5 bg-green-600 hover:bg-green-700 text-white px-3 py-1.5 text-xs font-bold uppercase transition-colors" data-testid={`verify-expert-${e.id}`}><Check className="w-3.5 h-3.5" /> Verifică</button>}
                {e.status !== "rejected" && <button onClick={() => onReject(e.id)} className="inline-flex items-center gap-1.5 bg-slate-700 hover:bg-slate-800 text-white px-3 py-1.5 text-xs font-bold uppercase transition-colors" data-testid={`reject-expert-${e.id}`}><X className="w-3.5 h-3.5" /> Respinge</button>}
                <button onClick={() => onEndorse(e.id)} className={`inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-bold uppercase transition-colors ${e.endorsed ? "bg-orange-600 text-white hover:bg-orange-700" : "border border-orange-600 text-orange-600 hover:bg-orange-50"}`} data-testid={`endorse-expert-${e.id}`}><BadgeCheck className="w-3.5 h-3.5" /> {e.endorsed ? "Retrage endorsement" : "OXO Endorse"}</button>
                <button onClick={() => onActivate(e.id)} className="inline-flex items-center gap-1.5 border border-slate-300 hover:border-slate-900 px-3 py-1.5 text-xs font-bold uppercase transition-colors" data-testid={`activate-expert-${e.id}`}><Power className="w-3.5 h-3.5" /> {e.active ? "Dezactivează" : "Activează (comp)"}</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
